import ReportScrollableTable from 'features/report/table/ReportScrollableTable'
import MultiTable from 'components/table/MultiTable'
import {
  ReportColumnBizChannelName,
  ReportColumnCampaignName,
  ReportColumnCampaignType,
  ReportColumnEndDate,
  ReportColumnStartDate,
} from 'features/report/common/ReportColumns'

const ReportCampaignTable = () => (
  <div className="table_wrap">
    <MultiTable.Container>
      <ReportScrollableTable
        caption="맞춤보고서 캠페인 테이블"
        baseColumns={[
          ReportColumnCampaignType,
          ReportColumnCampaignName,
          ReportColumnBizChannelName,
          ReportColumnStartDate,
          ReportColumnEndDate,
        ]}
      />
    </MultiTable.Container>
  </div>
)

export default ReportCampaignTable
